import { AfterViewInit, Directive, inject, OnChanges, OnInit } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';

@Directive({
  selector: '[ctrColorCheckbox]',
  standalone: true,
})
export class ColorCheckboxDirective implements OnInit, OnChanges, AfterViewInit {
  hotelColor = '#000';
  private elementRef = inject(MatCheckbox);

  /**
   * Lifecycle hook that is called after the directive's data-bound properties have been initialized.
   * Retrieves the primary and contrast colors from the CSS variables.
   */
  ngOnInit(): void {
    this.hotelColor = getComputedStyle(document.body).getPropertyValue('--ctr-primary-color');
  }

  /**
   * Lifecycle hook that is called after the view has been initialized.
   * Sets the color of the checkbox.
   */
  ngAfterViewInit(): void {
    this.setColor();
  }

  /**
   * Lifecycle hook that is called when any input property changes.
   * Sets the color of the checkbox.
   */
  ngOnChanges(): void {
    this.setColor();
  }

  setColor() {
    const element = this.elementRef._elementRef.nativeElement as HTMLElement;
    element.style.setProperty('--mdc-checkbox-selected-icon-color', this.hotelColor);
    element.style.setProperty('--mdc-checkbox-selected-hover-state-layer-color', this.hotelColor);
    element.style.setProperty('--mdc-checkbox-selected-hover-icon-color', this.hotelColor);
    element.style.setProperty('--mdc-checkbox-selected-focus-state-layer-color', this.hotelColor);
    element.style.setProperty('--mdc-checkbox-selected-focus-icon-color', this.hotelColor);
    element.style.setProperty('--mdc-checkbox-selected-pressed-state-layer-color', this.hotelColor);
    element.style.setProperty('--mdc-checkbox-selected-pressed-icon-color', this.hotelColor);
    element.style.setProperty('--mdc-slide-toggle-selected-handle-color', this.hotelColor);

    element.style.setProperty('--mat-checkbox-selected-icon-color', this.hotelColor);
    element.style.setProperty('--mat-checkbox-selected-hover-state-layer-color', this.hotelColor);
    element.style.setProperty('--mat-checkbox-selected-hover-icon-color', this.hotelColor);
    element.style.setProperty('--mat-checkbox-selected-focus-state-layer-color', this.hotelColor);
    element.style.setProperty('--mat-checkbox-selected-focus-icon-color', this.hotelColor);
    element.style.setProperty('--mat-checkbox-selected-pressed-state-layer-color', this.hotelColor);
    element.style.setProperty('--mat-checkbox-selected-pressed-icon-color', this.hotelColor);
    element.style.setProperty('--mat-slide-toggle-selected-handle-color', this.hotelColor);
  }
}
